import { useSelector } from 'react-redux';
import useDashboardActions from './_actions';

export const useDashboard = () => {
    const {
        fetchAdminDashboardData,
        fetchFinanceHODashboardData,
        fetchFinanceBODashboardData,
        fetchECClusterOwnerDashboardData,
        reCalculateLedger,
        resetDialog
    } = useDashboardActions();

    const adminData = useSelector(state => state.dashboard.admin);
    const financeHOData = useSelector(state => state.dashboard.financeHO);
    const financeBOData = useSelector(state => state.dashboard.financeBO);
    const ecommerceCOData = useSelector(state => state.dashboard.ecommerceCO);
    const isLoading = useSelector(state => state.dashboard.isLoading);
    const isError = useSelector(state => state.dashboard.isError);
    const errorMessage = useSelector(state => state.dashboard.errorMessage);
    const dialogStatus = useSelector(state => state.dashboard.dialogStatus);

    return {
        fetchAdminDashboardData,
        fetchFinanceHODashboardData,
        fetchFinanceBODashboardData,
        fetchECClusterOwnerDashboardData,
        reCalculateLedger,
        resetDialog,

        adminData,
        financeHOData,
        financeBOData,
        ecommerceCOData,
        isLoading,
        isError,
        errorMessage,
        dialogStatus
    }
}

export { default as dashboardReducer } from './_reducers';